import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { TasksService } from 'src/app/services/tasks.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { environment } from 'src/environments/environment';
import { CatalogsService } from 'src/app/shared/services/catalogs.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-task-review',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Tareas y técnicos</h1>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul #subnav app-nav-tasks [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex">
          <div class="flex-fill list-group rounded-4 rounded-md-5 mt-4">
            <div class="list-group-item table-responsive py-4" *ngIf="!loading">
              <div class="d-flex">
                <div class="flex-fill">
                  <h5>Resúmen de la tarea</h5>
                  <h2>#{{settlement?.data?.attributes?.id}} {{settlement?.data?.attributes?.name}}</h2>
                  <p class="mb-2"><small>{{settlement?.data?.attributes?.address}}, {{settlement?.data?.attributes?.city}}, {{settlement?.data?.attributes?.country}}</small></p>
                  <p class="mb-0" style="font-size: 17px;"><small>{{settlement?.data?.attributes?.email}}</small></p>
                </div>
              </div>
              <div class="d-flex">
                <div>
                  <div class="avatar-container text-center" style="left: 0 !important;" *ngIf="technician.id">
                    <div class="image-container border border-4" style="width: 100px; height: 100px;" *ngIf="techAvatar!=''">
                      <img [src]="techAvatar" width="100%">
                    </div>
                  </div>
                </div>
                <div class="ms-2 flex-fill">
                  <h5 class="mb-0">{{technician.name}} {{technician.last_name}}</h5>
                  <p class="text-muted" style="font-size: 14;">{{technician.email}}</p>
                </div>
              </div>
              <div class="d-flex mt-3">
                <div class="flex-fill">
                  
                    <div *ngFor="let building of settlement?.buildings">
                      <div *ngFor="let tanque of building.tanques">
                        <div *ngFor="let stat of tanque?.stats">
                          <div class="row border border-1 rounded-3 m-2 p-2" *ngIf="stat?.activity_type_id == 3">
                            <div class="col-md-7">
                              <div class="rounded-4 shadow-sm" style="overflow: hidden;">
                                <img [src]="loadImg(stat.item?.photo)" width="100%" />
                              </div>
                            </div>
                            <div class="col-md-5">
                              <h4>#{{tanque.id}} {{ tanque.name }}</h4>
                              <table class="table table-sm">
                                <tr *ngIf="stat.grade">
                                  <th>Calificación</th>
                                  <td>{{stat.grade}}</td>
                                </tr>
                                <tr *ngIf="stat.duration">
                                  <th>Duración</th>
                                  <td>{{stat.duration | number : '1.2-2' }}</td>
                                </tr>
                                <tr *ngIf="stat.item">
                                  <th>Lectura</th>
                                  <td>{{stat.item?.value}}</td>
                                </tr>
                                <tr *ngIf="stat.item">
                                  <th>Fecha</th>
                                  <td>{{stat.item?.created_at | date: 'dd/MM/yy'}}</td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>                          
                      <div *ngIf="building.units.length>0">
                        <h5>{{ building.name }}</h5>
                        <div class="list-group" *ngFor="let unit of building.units">
                          <div class="list-group-item" *ngIf="unit.stats.length !== 0">
                            <div *ngFor="let stat of unit.stats">
                              {{stat.activity_type_id}}
                              
                              <div class="row border border-1 rounded-3 m-2 p-2" *ngIf="stat.activity_type_id === 2">
                                <div class="col-md-3">
                                  <div class="rounded-4 shadow-sm" style="overflow: hidden;"><img [src]="stat.item?.included?.attributes?.gas_meter_read?.data?.attributes?.photo" width="100%"></div>
                                  <div class="rounded-4 shadow-sm" style="overflow: hidden;"><img [src]="loadImg(stat.item?.ocr_image)" width="100%"></div>
                                </div>
                                <div class="col-md-3">
                                  <p>Folio: {{stat.item?.id}}</p>
                                </div>
                                <div class="col-md-3">
                                  <p>Lectura: {{stat.item?.value}}</p>
                                  <p>OCR: {{stat.item?.ocr_value}}</p>
                                </div>
                                <div class="col-md-3">
                                  <p>Fecha: {{stat.item?.created_at | date: 'dd/MM/yy HH:mm'}}</p>
                                </div>
                              </div>

                              <div class="row border border-1 rounded-3 m-2 p-2" *ngIf="stat.activity_type_id === 3"></div>
                              <div class="row border border-1 rounded-3 m-2 p-2" *ngIf="stat.activity_type_id === 4"></div>
                              <div class="row border border-1 rounded-3 m-2 p-2" *ngIf="stat.activity_type_id === 5">
                                {{stat | json}}
                              </div>
                              <div class="row border border-1 rounded-3 m-2 p-2" *ngIf="stat.activity_type_id === 6">
                                {{stat | json}}
                              </div>

                              <div class="d-flex" *ngIf="stat.activity_type_id === 7">
                                <div class="flex-fill d-flex">
                                  <h4>#{{unit.id}} {{ unit.name }}</h4>
                                </div>
                                <div class="d-flex" *ngFor="let include of stat.item?.included">
                                  <div class="flex-fill d-flex flex-column">
                                
                                    <div class="rounded-4 shadow-sm" style="overflow: hidden;" *ngIf="include.attributes?.gas_meter_read?.data?.attributes?.photo"><img [src]="include.attributes?.gas_meter_read?.data?.attributes?.photo" width="240px"></div>
                                    <div class="rounded-4 shadow-sm" style="overflow: hidden;" *ngIf="stat.item?.medidor"><img [src]="loadImg(stat.item?.medidor)" width="100%"></div>
                                    <div class="rounded-4 shadow-sm" style="overflow: hidden;" *ngIf="stat.item?.ocr_image"><img [src]="loadImg(stat.item?.ocr_image)" width="100%"></div>
                                  </div>
                                  <div>
                                    <table class="table table-sm">
                                      <tr *ngIf="stat.grade">
                                        <th>Calificación c</th>
                                        <td class="text-end">{{stat.grade | number : '1.2-2'}}</td>
                                      </tr>
                                      <tr *ngIf="unit.stats[0].duration">
                                        <th>Duración</th>
                                        <td class="text-end">{{unit.stats[0].duration | number : '1.2-2' }}</td>
                                      </tr>
                                      <tr *ngIf="unit.stats[0].item">
                                        <th>Recibo #</th>
                                        <td class="text-end"><a routerLink="/pagos/recibos/{{unit.stats[0].item?.id}}">{{unit.stats[0].item?.data?.id}}</a></td>
                                      </tr>
                                      <tr *ngIf="unit.stats[0].item">
                                        <th>Lectura en recibo</th>
                                        <td class="text-end">{{unit.stats[0].item?.read_curr}}</td>
                                      </tr>
                                      <tr *ngIf="unit.stats[0].item">
                                        <th>Lectura original</th>
                                        <td class="text-end">{{unit.stats[0].item?.value}}</td>
                                      </tr>
                                      <tr *ngIf="unit.stats[0].item">
                                        <th>Fecha</th>
                                        <td class="text-end">{{unit.stats[0].item?.created_at | date: 'dd/MM/yy'}}</td>
                                      </tr>
                                    </table>
                                  </div>
                                </div>
                              </div>

                              <div class="row border border-1 rounded-3 m-2 p-2" *ngIf="stat.activity_type_id === 8"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ms-2">
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <div class="d-flex">
              <div class="flex-fill text-center">
                <div *ngIf="task.status" class="badge badge-pill badge-lg rounded-5 px-5 py-3" [style]="{ backgroundColor: catalog.status[task.status].color, color: catalog.status[task.status].text }">{{catalog.status[task.status].name}}</div>
              </div>
            </div>
            <div class="d-flex mt-3">
              <div class="flex-fill text-center">
                <h1 [countUp]="grade" [duration]="1000" style="font-size: 50px;" class="mb-0"></h1>
                <p>Calificación</p>
              </div>
            </div>
            <div class="d-flex mt-3">
              <div class="flex-fill">
                <table class="table">
                  <tr>
                    <td>Programada:</td>
                    <td>{{task.due_date | date: 'dd/MM/yy'}} {{task.due_time | date: 'HH:mm'}}</td>
                  </tr>
                  <tr>
                    <td>Completada:</td>
                    <td>{{task.completed_at | date: 'dd/MM/yy HH:mm'}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="d-flex mt-3">
              <div class="text-center mt-3 mb-4">
                <button class="btn btn-lg btn-outline-primary rounded-4 w-100" [disabled]="loading" (click)="downloadCSV()">Descargar reporte</button>
              </div>
            </div>
            <div class="d-flex">
              <div class="flex-fill">
                <h5>Constructor</h5>
                <div class="list-group">
                  <div class="list-group-item rounded-2" *ngFor="let activity of activities">
                    <div class="row">
                      <div class="col-md-8">
                        {{ activity.name }}
                      </div>
                      <div class="col-md-4 text-end">
                        {{ activity.weight }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="flex-fill">
                <h5 class="mb-2 mt-4">Habilidades requeridas</h5>
                <div *ngIf="task.skills?.length>0">
                  <div class="list-group-item" *ngFor="let skill of task.skills">
                    <div class="row">
                      <div class="col-md-8">
                        {{ skill.name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="task.skills?.length==0">
                  <div class="list-group">
                    <div class="list-group-item text-center">No se requieren habilidades</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="flex-fill">
                <h5 class="mb-2 mt-4">Herramientas requeridas</h5>
                <div *ngIf="task.tools?.length>0">
                  <div class="list-group-item" *ngFor="let tool of task.tools">
                    <div class="row">
                      <div class="col-md-8">
                        {{ tool.name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="task.tools?.length==0">
                  <div class="list-group">
                    <div class="list-group-item text-center">No se requieren herramientas</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class TaskReviewComponent implements OnInit {
  apiUrl: string = environment.AWS_REST_WSPREFIX;
  profile: any = {};
  task: any = {};
  builder: any = {};
  grade: number = 0;
  activities: any = [];
  settlement: any = {};
  technician: any = {};
  fullData: any = {};
  loading: boolean = false;

  techAvatar: string = '';
  currentView: string = 'tasks';

  downloading: boolean = false;
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private taskService: TasksService,
    private router: Router,
    private toastr: ToastrService,
    private activateRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    public catalog: CatalogsService,
    public icons: IconsService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE);
    this.loading = true;
    this.activateRoute.params.subscribe((params) => {
      this.taskService.getTaskReview(params['id']).subscribe((res: any) => {
        console.log('res', res);
        this.fullData = res;
        this.task = res.task;
        this.builder = res.builder;
        this.activities = res.activities;
        this.settlement = res.settlement;
        this.grade = res.grade.toFixed(2);
        this.technician = res.user;
        this.breadcrumbService.set('@TaskEdit', 'Resumen de la tarea ' + res.id);
        this.loading = false;
      });
    });
  }

  ngOnInit(): void {}

  async downloadCSV() {
    this.downloading = false;
    let options = {
      title: 'Reporte de tarea',
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      noDownload: false,
      showTitle: true,
      useBom: true,
      headers: [
        "# Tarea",
        "# Actividad",
        "Calificación",
        "Duración",
        "Peso",        
        "Condominio",
        "Edificio",
        "Unidad",
        "Técnico",
        "Lectura",
        "Fecha"
      ]
    };

    let stats: any = [];
    console.log('CONDOMINIO ===> ', this.settlement)
    await this.settlement.buildings.map((building: any) => {
      console.log('MAP building', building);
      building.units.map((unit: any) => {
        unit.stats.map((stat: any) => {
          stats.push({
            task_id: this.task.id,
            id: stat.id,
            grade: stat.grade,
            duration: stat.duration,
            weight: stat.weight,
            settlement_id: this.settlement.name,
            building: building.name,
            unit_id: unit.name,
            tecnico: `${this.technician.name} ${this.technician.last_name}`,
            lectura: stat.item.value,
            fecha: stat.item.created_at
          });
        });
      });
    });

    console.log('stats', stats);

    new ngxCsv(stats, 'Reporte', options);
    this.downloading = false;
  }

  loadImg(img: any) {
    if (img && img.blob) {
      return `${this.apiUrl}/storage/${img.blob.key.substring(0,2)}/${img.blob.key.substring(2,4)}/${img.blob.key}`;
    } else {
      return '';
    }
  }
}
